import styled from 'styled-components';
import Wrapper from '../../Wrapper/Wrapper';

const ProductInfoCardWrapper = styled(Wrapper)`
  > *,
  > * > * {
    ${props => `font-size: ${props.fontSize}`};
  }
`;

export default ProductInfoCardWrapper;
